<div class="wrapper-md" *ngIf="isReady">
    <app-breadcrumbs [items]="[{ text: title || code }]"></app-breadcrumbs>

    <app-alert level="danger" *ngIf="error; else form">{{'eServiceNotAvailable' | translate}}</app-alert>

    <ng-template #form>
        <header class="content-header">
            <h1>{{title}}</h1>
        </header>

        <div class="block-body">
            <app-alert *ngIf="textBefore" level="info">
                <div [innerHTML]="textBefore | safeHtml"></div>
            </app-alert>

            <div *ngIf="content" [innerHTML]="content | safeHtml"></div>

            <div *ngIf="textAfter" class="mt-3">
                <app-alert level="info">
                    <div [innerHTML]="textAfter | safeHtml"></div>
                </app-alert>
            </div>
        </div>
    </ng-template>
</div>
